// extracted by mini-css-extract-plugin
module.exports = {"customSuccess":"styles_customSuccess__1GT8z","customInfo":"styles_customInfo__3Abax","customDanger":"styles_customDanger__2QKPh"};